// Quem pode editar/excluir/vincular POs (regra que já existia no card, agora compartilhada com a Gestão).
const purchaseOrderManagers = [
  "ricardorkarnopp@gmail.com",
  "jhonatan@cvftrading.com.br",
];

export const canManagePurchaseOrders = (auth?: { email?: string } | null) =>
  purchaseOrderManagers.includes(auth?.email ?? "");
